import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";


export class TriggerCurrency extends TriggerBase {

    constructor() {
        super(TriggerKind.CURRENCY);
        this._currency = null;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    valid() {
        if (!super.valid()) {
            return false;
        }

        return CurrencyKindModel.is(this.currency);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerCurrency());
        } else if (target instanceof TriggerCurrency) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerCurrencyScope extends TriggerScope {

    static _values = [
        new TriggerCurrencyScope(1, "ADD_AMOUNT"),
        new TriggerCurrencyScope(2, "REM_AMOUNT"),
        new TriggerCurrencyScope(3, "MIN_AMOUNT"),
        new TriggerCurrencyScope(4, "NOT_ENOUGH"),
        new TriggerCurrencyScope(5, "HAS_AMOUNT")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerCurrencyScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerCurrencyScope());
        } else if (target instanceof TriggerCurrencyScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerCurrency, {
    _scope: alias("scope", TriggerCurrencyScope.schema()),
    _currency: alias("currency_kind", CurrencyKindModel.schema())
});